import React from "react";
import ModuleHeader from "../modules/ModuleHeader";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div>
      <ModuleHeader title={t("Page not found")} />

      <div className="lg:px-0 px-3">
        <div className="bg-white shadow rounded py-10 px-10 min-h-screen">
          <div className="flex justify-center my-3">
            <iframe
              src="https://giphy.com/embed/MBOaAoOr2jzoNneBJ4"
              width="480"
              height="480"
              frameBorder="0"
              className="giphy-embed"
              allowFullScreen
            ></iframe>
          </div>
          <div className="space-y-6 text-center">
            <div>
              Sometimes, the things we love can break. Don't worry; we've
              recovered your progress.
            </div>
            <div>
              A veces, las cosas que amamos pueden romperse. No se preocupe,
              hemos recuperado su progreso.
            </div>
            <div>
              有时候，我们所爱的事物可能会破裂。不用担心，
              我们已经恢复了您的进度。
            </div>
            <div>
              Parfois, les choses que nous aimons peuvent se briser. Ne vous
              inquiétez pas, nous avons récupéré votre progression.
            </div>
            <div>
              Às vezes, as coisas que amamos podem quebrar. Não se preocupe, nós
              recuperamos seu progresso.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
